<mat-toolbar color="white" class="header-toolbar">
    <div class="logo-container">
        <img src="assets/images/logo-quelix.png" alt="Quelix Logo" class="logo" />
    </div>

    <span class="spacer"></span>

    <button type="button" class="admin-trigger" [matMenuTriggerFor]="adminMenu" #menuTrigger="matMenuTrigger" [matMenuTriggerRestoreFocus]="false" [attr.aria-haspopup]="'menu'" [attr.aria-expanded]="menuTrigger.menuOpen" [attr.aria-label]="'Apri menu utente: ' + userInfo.firstName + '' + userInfo.lastName + ' (' + userInfo.email + ')'">
  <div class="user-block">
    <div class="user-text">
      <div class="user-name">{{ userInfo.firstName }} {{userInfo.lastName}}</div>
      <div class="user-email">{{ userInfo.email }}</div>
    </div>
    <div class="avatar-wrapper">
      <img [src]="profileImageUrl" alt="Foto profilo" class="profile-pic" (error)="handleImageError()" />
    </div>
  </div>
</button>

    <mat-menu #adminMenu="matMenu" yPosition="below" xPosition="before">
        <button mat-menu-item (click)="goToProfilePage(userInfo)">Profilo</button>
        <button mat-menu-item class="text-danger" (click)="logout()">Logout</button>
    </mat-menu>

</mat-toolbar>